import { useContext, useEffect } from 'react'

import { useLazyQuery } from '@apollo/react-hooks'
import packageProductQuery from '../Queries/PackageProductQuery.gql'
import { SiteContext } from '../../Global/SiteContext'

export function useHandleProductNumberAndPackage(productData) {
   const { setActiveProductNumber, setPackageProducts } =
      useContext(SiteContext)

   const [getPackage] = useLazyQuery(packageProductQuery, {
      onCompleted: data => {
         setPackageProducts(data?.product?.package?.items)
      },
   })

   useEffect(() => {
      if (productData?.articleNumber) {
         if (productData?.isPackage && productData?.articleNumber) {
            getPackage({
               variables: { articleNumber: productData?.articleNumber },
            })
         } else {
            setPackageProducts(prev => (prev === null ? prev : null))
         }
         setActiveProductNumber(productData?.articleNumber)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [productData?.articleNumber])
}
